import { render } from "./EditHeader.vue?vue&type=template&id=8657b8aa"
import script from "./EditHeader.vue?vue&type=script&lang=js"
export * from "./EditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__